module.exports = __webpack_public_path__ + "img/mr.ab507d1c.svg";